module.exports = __webpack_public_path__ + "img/img_icon_40_1.6d02bc9f.png";